<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="汽车名称" prop="fullname">
      <el-input v-model="ruleForm.fullname" class="fullname_input"></el-input>
    </el-form-item>
    <el-form-item label="汽车品牌" prop="brand" class="choose">
      <el-select v-model="ruleForm.brand" placeholder="请选择汽车品牌">
<!--        <el-option label="区域一" value="1"></el-option>-->
        <el-option
            v-for="(brand,index) in brandList"
            :key="index"
            :label="brand.brandinfo"
            :value="brand.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="汽车类型" prop="category" class="choose">
      <el-select v-model="ruleForm.category" placeholder="请选择汽车类型">
        <el-option label="轿车" value="轿车"></el-option>
        <el-option label="跑车" value="跑车"></el-option>
        <el-option label="SUV" value="SUV"></el-option>
        <el-option label="越野" value="越野"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="购买时间" required class="paydate_style">
      <el-col :span="11" class="paydate_style_col-11">
        <el-form-item prop="paydate">
          <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.paydate" style="width: 100%;"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="行驶里程" prop="distance" class="choose">
      <el-input v-model.number="ruleForm.distance">
        <template slot="append">公里</template>
      </el-input>
    </el-form-item>
    <el-form-item label="车源信息" prop="ownernum">
      <el-radio-group v-model="ruleForm.ownernum">
        <el-radio label="一手自用"></el-radio>
        <el-radio label="二手过户"></el-radio>
        <el-radio label="多次转手"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="变速箱类型" prop="gearbox" class="choose">
      <el-select v-model="ruleForm.gearbox" placeholder="请选择变速箱类型">
        <el-option label="手动" value="手动"></el-option>
        <el-option label="自动" value="自动"></el-option>
        <el-option label="手自一体" value="手自一体"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="汽车排量" prop="displacement" class="choose">
      <el-input v-model="ruleForm.displacement">
        <template slot="append">T/L</template>
      </el-input>
    </el-form-item>
    <el-form-item label="颜色" prop="color" class="choose">
      <el-input v-model="ruleForm.color"></el-input>
    </el-form-item>
    <el-form-item label="售价" prop="price">
      <el-input v-model="ruleForm.price" class="price_input">
        <template slot="append">万</template>
      </el-input>
    </el-form-item>

    <el-upload
        class="upload-demo"
        action="#"
        :auto-upload="false"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-change="handleChange"
        :file-list="fileList"
        :limit="3"
        :on-exceed="handleExceed"
        list-type="picture">
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">请上传汽车正面照片一张，侧面照片两张</div>
    </el-upload>


    <el-form-item class="item_commit">
      <el-button type="primary" @click="submitForm('ruleForm')"  :loading="successSell">立即售卖</el-button>
      <el-button @click="resetForm('ruleForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "SellCar",


  data() {
    return {
      successSell:false,
      ruleForm: {
        userid: this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user.id :'',
        fullname: '',
        brand: '',
        category: '',
        paydate: '',
        distance: '',
        ownernum: '',
        gearbox: '',
        displacement: '',
        color: '',
        price: '',
        },
      fileList: [],
      brandList:[],
      // fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}]
// ,
      rules: {
        fullname: [
          {required: true, message: '请输入汽车名称', trigger: 'blur'},
          {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
        ],
        brand: [
          {required: true, message: '请选择汽车品牌', trigger: 'change'}
        ],
        category: [
          {required: true, message: '请选择汽车类型', trigger: 'change'}
        ],
        paydate: [
          {type: 'date', required: true, message: '请选择日期', trigger: 'change'}
        ],
        distance: [
          {required: true, message: '请输入行驶里程', trigger: 'blur'}
        ],
        ownernum: [
          {required: true, message: '请选择一个车源信息', trigger: 'change'}
        ],
        gearbox: [
          {required: true,message: '请选择变速箱类型', trigger: 'change'}
        ],
        price: [
          {required: true,message: '请输入预期售价', trigger: 'blur'}
        ],
        imgone: [
          {required:true, message: '请上传第一张照片', trigger: 'blur'}
        ],
        imgtwo: [
          {required:true, message: '请上传第二张照片', trigger: 'blur'}
        ],
        imgthree: [
          {required: true, message: '请上传第三张照片', trigger: 'blur'}
        ]
      }
    };
  },
  methods: {
    handleChange(file,fileList){
      const isLt2M = file.size / 1024 / 1024 < 2     //这里做文件大小限制
      if(!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        });
        return isLt2M
      }else {
        this.fileList = fileList;
      }
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview(file) {

    },
    handleExceed(file,fileList){
      this.$message.warning("文件选择过多")
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if(this.fileList.length === 0){
          this.$message.error("请上传车辆照片")
          return false;
        }
        if (valid) {
          this.successSell = true
          var fd = new FormData()
          this.ruleForm.distance = this.ruleForm.distance.toString()
          this.ruleForm.brand = this.ruleForm.brand.toString()
          this.ruleForm.displacement = this.ruleForm.displacement.toString()
          this.ruleForm.color = this.ruleForm.color.toString()
          this.ruleForm.price = this.ruleForm.price.toString()
          fd.append("carinfo",JSON.stringify(this.ruleForm))
          this.fileList.forEach(file => {
            fd.append('file', file.raw)
          })
          this.axios.post("/car/uploadCarInfo",fd).then(res=>{
            if(res.data.code == 0){
              this.$message.success("发布成功，待审核中。")
              //清空信息
              this.resetForm('ruleForm')
              this.fileList = []
              this.successSell = false
              this.$router.replace("/index/buy")
            }else {
              this.$message.error(res.data.data.message)
            }

          })
        } else {
          this.$message.error("信息填写有误，请检查")
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created(){
    this.axios.get("/car/getCarBrandList").then(res => {
      if(res.data.code === 0){
        this.brandList = res.data.data.brandList
      }
    })
  },


}
</script>

<style scoped>

.demo-ruleForm{
  padding-top: 2%;
}

.fullname_input {
  width: 50%;
}

.choose {
  display: inline-block;
}

.paydate_style {
  display: inline-block;
}
.paydate_style_col-11 {
  width: auto;
  float: none;
}

.price_input {
  width: 10%;
}

.choose_img {
  display: inline-block;
  margin-left: 10%;
}

.upload-demo {
  display: inline-block;
  /*text-align: center;*/
  margin-left: 6%;
}

.el-upload__tip {
  margin-left: -25%;
}

.item_commit {
  margin-left: 30%;
}
</style>